import { Component } from '@gondel/core';
import { GondelJqueryComponent } from '@gondel/plugin-jquery';
import addComponentAnimation from '@swisslife/shared-ui/src/utils/animations/js/animations';

// The @Component decorator will connect the class with `data-g-name="Listing"` elements.
@Component('Listing')
export class Listing extends GondelJqueryComponent {
	private controllers: any[] = Array();

	public async sync() {
		this.controllers = await addComponentAnimation(this.$ctx);
	}

	public stop() {
		for (const controller of this.controllers) {
			controller.destroy(true);
		}
	}
}
